var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.showcases),function(item){return _c('ShowcaseProducts',{key:item.id,attrs:{"name":item.name,"products":item.products}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }